import { render, staticRenderFns } from "./EnvelopeBottom.vue?vue&type=template&id=ea1bdd9e&lang=pug"
import script from "./EnvelopeBottom.vue?vue&type=script&lang=js"
export * from "./EnvelopeBottom.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeBottom.vue?vue&type=style&index=0&id=ea1bdd9e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports